// AI GIF Generator client.
// Talks to the standalone AIGIFGenerator microservice (see G:\AIGIFGenerator).
// The service generates synchronously and returns a final hosted URL; the
// caller hands that URL to the normal "send a GIF" path.

const BASE = process.env.REACT_APP_AIGIF_URL || 'http://localhost:6800';
const API_KEY = process.env.REACT_APP_AIGIF_KEY || 'dev-local-key';

/**
 * Generate an animated WebP from a text prompt.
 * @param {string} prompt
 * @param {(status: string) => void} [onStatus] optional progress callback
 * @returns {Promise<string>} hosted URL of the generated animation (.webp)
 */
export async function generateAiGif(prompt, onStatus) {
  if (onStatus) onStatus('processing');
  // One synchronous request; the service runs the whole pipeline (~15-90s).
  const res = await fetch(`${BASE}/generate`, {
    method: 'POST',
    headers: { 'content-type': 'application/json', 'x-api-key': API_KEY },
    body: JSON.stringify({ prompt }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.status === 'error') {
    throw new Error(data.error || `generate failed: ${res.status}`);
  }
  if (onStatus) onStatus('done');
  return data.url;
}
